import { Flex, Modal, Spin } from 'antd';

import styles from '../Components.module.css';
import image from '../../studio/assets/purchase_complete.png';
import { useDispatch, useSelector } from 'react-redux';
import { setPaymentState } from '../../actions';
import { PaymentState } from '../../types';
import { LoadingOutlined } from '@ant-design/icons';
import { IState } from '../../graphql/types';

const PaymentCompleteModal = () => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setPaymentState(PaymentState.idle));
  };

  const paymentStatus = useSelector<IState, PaymentState>(
    state => state.paymentState
  );

  return (
    <Modal
      onCancel={handleClose}
      centered
      open={
        paymentStatus === PaymentState.processing ||
        paymentStatus === PaymentState.successful
      }
      cancelText={null}
      width={'fit-content'}
      footer={null}
    >
      <div className={styles.paymentCompleteModal}>
        {paymentStatus === PaymentState.processing ? (
          <Spin
            size={'large'}
            indicator={<LoadingOutlined />}
            tip={'Please wait while we process your payment.'}
          >
            <div></div>
          </Spin>
        ) : (
          <Flex gap={'large'}>
            <img src={image} alt={'A person creating giides'} />
            <div>
              <h1>You're all set</h1>
              <div>Thank you for choosing Giide. Happy creating!</div>
            </div>
          </Flex>
        )}
      </div>
    </Modal>
  );
};

export default PaymentCompleteModal;
